import { revokedBadgeReasonsClassifierEntityName, } from '../../../../backend/config/classifiers/revoked-badge-reasons-classifier/types';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.title;
}
const EntityDetailsComponent = (props) => {
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Name', value: capitalize(props.response.data.name) },
            { label: 'Title', value: capitalize(props.response.data.title) },
            { label: 'Description', value: props.response.data.description },
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Can Reissue', value: props.response.data.canReissue },
        ] }));
};
const formConfig = {
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.text',
            key: 'title',
            label: 'Title',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.text',
            key: 'description',
            label: 'Description',
            validate: {
                required: false,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.checkbox',
            key: 'canReissue',
            label: 'Can Reissue',
            validate: {
                required: false,
            },
        },
    ],
};
export const RevokedBadgeReasonsAdminPage = () => {
    const { t } = useBadgingTranslation();
    return (React.createElement(ClassifierAdminPage, { entity: revokedBadgeReasonsClassifierEntityName, title: 'Revoked Badge Reasons', tableColumns: [
            {
                headerLabel: t('classifiers.revokedBadgeReasonsAdminPage.table.columnTitle'),
                sortKey: 'title',
                cellFunction: (row) => React.createElement(TextCell, null, getEntityTitle(row)),
            },
            {
                headerLabel: t('classifiers.revokedBadgeReasonsAdminPage.table.description'),
                sortKey: 'description',
                cellFunction: (row) => React.createElement(TextCell, null, row.columns.description),
            },
            {
                headerLabel: t('classifiers.revokedBadgeReasonsAdminPage.table.columnStatus'),
                sortKey: 'status',
                cellFunction: (row) => React.createElement(TextCell, null, row.columns.status),
            },
            {
                headerLabel: t('classifiers.revokedBadgeReasonsAdminPage.table.columnCanReissue'),
                sortKey: 'canReissue',
                cellFunction: (row) => React.createElement(TextCell, null, row.columns.canReissue ? 'YES' : 'NO'),
            },
        ], getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, defaultSortColumnKey: 'title', formConfig: formConfig, formWidth: 1200, fullTextSearchField: 'title' }));
};
